export default __webpack_public_path__ + "static/media/full-logo-dark.a57372ad.png";